"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m9.43 4.92a1.6 1.6 0 0 0 -1.59 1.6c0 .84 1.45 3.05 1.51 3.14a.1.1 0 0 0 .08.05.11.11 0 0 0 .09-.05c.06-.09 1.48-2.3 1.48-3.14a1.6 1.6 0 0 0 -1.57-1.6zm0 2.29a.7.7 0 1 1 .7-.69.7.7 0 0 1 -.7.69z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.25 11.18a2.89 2.89 0 0 0 -2.88 2.89c0 1.53 2.62 5.52 2.73 5.69a.19.19 0 0 0 .15.08.18.18 0 0 0 .15-.08c.12-.17 2.74-4.16 2.74-5.69a2.9 2.9 0 0 0 -2.89-2.89zm0 4.15a1.26 1.26 0 1 1 1.27-1.26 1.27 1.27 0 0 1 -1.27 1.26z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m19.11 8.33a2.12 2.12 0 0 0 -2.11 2.12c0 1.13 1.93 4.07 2 4.19a.14.14 0 0 0 .11.06.11.11 0 0 0 .11-.06c.09-.12 2-3.06 2-4.19a2.13 2.13 0 0 0 -2.11-2.12zm0 3.05a.93.93 0 1 1 .93-.93.93.93 0 0 1 -.93.93z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.51 10.93a.39.39 0 0 1 -.21-.06l-3.63-2.42a.38.38 0 0 1 -.1-.52.37.37 0 0 1 .51-.1l3.63 2.42a.36.36 0 0 1 .1.51.35.35 0 0 1 -.3.17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m9.51 16.69a.37.37 0 0 1 -.16-.69l7.36-3.43a.37.37 0 1 1 .31.67l-7.35 3.41a.32.32 0 0 1 -.16.04z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m1.57 11.29h20.85v1.4h-20.85z",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -4.97 12)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 1.57a10.43 10.43 0 1 1 -10.43 10.43 10.44 10.44 0 0 1 10.43-10.43m0-1.57a12 12 0 1 0 12 12 12 12 0 0 0 -12-12z"
  })));
};

exports["default"] = _default;